@if (field.readonly) {
    <input kui-input="{{ field.id }}"
        type="text"
        [disabled]="true"
        [value]="field.getText && field.getText(field, values)">
} @else {
    <kui-tag-input
        [invalid]="error || (field.required && (dirty && touched) && selectedItems().length === 0)"
        [placeholder]="'FORMS.CLIENTFILTER.PLACEHOLDER' | translate"
        [loading]="isLoading"
        [autoCompleteItems]="autoCompleteItems"
        [remoteSearch]="true"
        [selectedItems]="selectedItems()"
        (itemAdded)="addTag($event)"
        (itemRemoved)="removeTag($event)"
        (searchTermChanged)="updateAutoCompletionList($event)"
        [multiple]="field.max !== 1"></kui-tag-input>
}

@if (field.required && (dirty && touched) && selectedItems().length === 0) {
    <div class="invalid-feedback d-block">
        <div>{{ 'FORMS.SHARED.REQUIRED' | translate:{ field: field.title } }}</div>
    </div>
}

@if (error) {
    <div class="invalid-feedback d-block">
        <div>{{ error }}</div>
    </div>
}